/* eslint-disable */
import { User } from '@core/user/user.types';

export const user: User = {
    id: '3',
    name    : 'David Misael Villegas Sandoval',
    email   : 'personal@davidmisael.me',
    avatar  : 'https://i.ibb.co/3BnXD0w/foto-personal.jpg',
};
